// Stand-in for nav items wired in later phases. Keeps the shell feel complete.

interface Props {
  title: string;
  phase: string;
}

export function ComingSoon({ title, phase }: Props) {
  return (
    <div className="px-8 pt-7 pb-12 max-w-[1180px]">
      <div className="mb-6">
        <h1 className="text-[21px] font-semibold leading-tight -tracking-[0.01em] mb-1">
          {title}
        </h1>
        <p className="text-[13.5px] text-text-2">Lands in {phase}.</p>
      </div>
      <div className="qb-card p-10 text-center">
        <div className="text-[14px] text-text-2">Coming up.</div>
      </div>
    </div>
  );
}
